<template>
  <div class="ion-page">
    <ion-header-bar class="bar-positive">
      <h1 class="title">
        <span>
          <img class="title-image" src="../../assets/logo.png" height="80%" />
          You Must Change Your User Id and Password</span
        >
      </h1>
    </ion-header-bar>
    <ion-content class="ion-padding">
      <ion-spinner
        class="spinner"
        v-if="showSpinner"
        name="bubbles"
      ></ion-spinner>
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size-md="6" size-lg="5" size-xs="12">
            <div padding>
              <ion-item>
                <ion-input
                  type="text"
                  :value="userName"
                  ref="theUserName"
                  name="userName"
                  placeholder="New Username"
                ></ion-input>
              </ion-item>
              <ion-item>
                <ion-input
                  type="password"
                  :value="userPassword"
                  ref="theUserPassword"
                  name="userPassword"
                  placeholder="New Password"
                ></ion-input>
              </ion-item>
            </div>
            <div padding>
              <ion-button
                size="default"
                id="patientLogin"
                class="adjust-font-size"
                @click="changeCredentials"
                expand="block"
                >Update User Id and Password</ion-button
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
var AuthorizationRepository = Repository.get("authorization");
export default {
  name: "adminlogin",
  data() {
    return {
      info: null,
      userName: "",
      userPassword: "",
      showSpinner: false,
    };
  },

  methods: {
    changeCredentials: async function () {
      let self = this;
      this.userName = this.$refs.theUserName.value;
      this.userPassword = this.$refs.theUserPassword.value;

      if (this.userName.length < 1) {
        alert("Please input new user id");
        return;
      }

      if (this.hasWhiteSpace(this.userName)) {
        alert("User Id Cannot Contain Whitespace");
        return;
      }

      if (this.userPassword.length < 1) {
        alert("Please input new user password");
        return;
      }

      if (this.hasWhiteSpace(this.userPassword)) {
        alert("User Password Cannot Contain Whitespace");
        return;
      }

      var userLogin = {
        UserName: this.userName,
        Password: this.userPassword,
        OldUserName: this.$store.state.userName,
        OldPassword: this.$store.state.password,
      };

      this.showSpinner = true;

      var result = await AuthorizationRepository.changeCredentials(userLogin);
      if (result.data.status === "Success") {
        // eslint-disable-next-line no-console
        console.log(result);
        this.$store.state.location = result.data.location;
        this.$store.state.userName = result.data.userName;
        this.$store.state.email = result.data.email;
        this.$store.state.city = result.data.city;
        this.$store.state.firstName = result.data.firstName;
        this.$store.state.lastName = result.data.lastName;
        this.$store.state.dateOfBirth = result.data.dateOfBirth;
        this.$store.state.sex = result.data.sex;
        this.$store.state.homePhone = result.data.homePhone;
        this.$store.state.userId = result.data.userId;

        this.showSpinner = false;

        self.$router.push({
          name: "main",
          params: { data: this.$store.state.userId },
        });
      } else if (result.data.status === "Failure") {
        this.showSpinner = false;
        alert(result.data.errorMessage);
      }
    },
    hasWhiteSpace(s) {
      return s.indexOf(" ") >= 0;
    },
  },
};
</script>
